export enum CameraChannelType {
    Standard,
    ADASSensor,
    DMSSensor,
    BlindSpotSensor
}
